<template>
	<div>
		<div class="d-none">
			<div ref="pdf_content">
				<table cellspacing="0" cellpadding="0"
					style="font-family:Arial; width:525.75pt; margin-right:auto; margin-left:auto; border:0.75pt solid #ffffff; border-collapse:collapse;">
					<tbody>
						<tr>
							<td width="80%"
								style="border-right:1.5pt solid #2c246d; padding:0.75pt 8.25pt 0.75pt 0.38pt; vertical-align:middle;">
								<p style="margin-top:0pt; margin-bottom:0pt; text-align:right; font-size:10pt; line-height: 13pt;">
									<strong>FINTOS CAPITAL SDN. BHD.</strong>
									<span style="font-size:13.5pt;">&nbsp;198401014613 (127169-T)</span><br>
									<strong><em><span>(Formerly known as Invinity Credit Sdn. Bhd.)</span></em></strong><br>
									<span>Puchong Financial Corporate Centre, Lot No. 11F-2, 11th Floor,</span><br>
									<span>Tower 4 @ PFCC, Jalan Puteri 1/2, Bandar Puteri, 47160 Puchong, Selangor.</span><br>
									<strong><span style="color:#2dbe7a;">Tel (O)</span></strong>
									<span style="color:#2dbe7a;">&nbsp;</span>
									<span>03-8080 9777 (Press No.4) |&nbsp;</span>
									<strong><span style="color:#2dbe7a;">(M)</span></strong>
									<strong><span> </span></strong>
									<span>+6012-347 9128&nbsp;</span><br><span>General Email: enquiryfintoscapital@fintos.com.my</span>
								</p>
							</td>
							<td style="vertical-align:middle;">
								<p style="margin-top:0pt; margin-bottom:0pt; text-align:right; line-height:150%; font-size:10pt;"><img
										:src="base64Logo" width="192" height="75" alt=""></p>
							</td>
						</tr>
					</tbody>
				</table>
				<div id="doc_redemption_letter">
					<table>
						<tbody>
							<tr>
								<td style="color:#ff0000; width: 50px;"><strong>Ref</strong></td>
								<td style="color:#ff0000; width: 5px;"><strong>:</strong></td>
								<td style="color:#ff0000;"><strong>{{ _gHlp.getValue(activeCase, 'case_no', '-') }}</strong></td>
							</tr>
							<tr>
								<td>Date</td>
								<td>:</td>
								<td>{{ _gHlp.getCurrentDateTime(false) | dateTimeDynamicFormat('D MMMM YYYY') }}</td>
							</tr>
						</tbody>
					</table>
					<div class="mb-3">
						<strong> {{ _gHlp.getValue(activeCustomer, 'name', '-') }}</strong><br />
						<strong>(NRIC NO. : {{ _gHlp.getValue(activeCustomer, 'nric', '') | formatNRIC }})</strong><br><br>
						<p>{{ _gHlp.getValue(activeCustomer, 'locations.nric.address_1', '') }}</p>
					</div>
					<div class="mb-2">
						<p>Dear Sir/Madam,</p>
					</div>
					<table>
						<tbody>
							<tr>
								<td colspan="3"><strong><u>RE: REDEMPTION STATEMENT</u></strong></td>
							</tr>
							<tr>
								<td style="width: 110px;"><strong>BORROWER</strong></td>
								<td>:</td>
								<td><strong>{{ _gHlp.getValue(activeCustomer, 'name', '-') }}</strong></td>
							</tr>
							<tr>
								<td><strong>ACCOUNT NO.</strong></td>
								<td>:</td>
								<td><strong>{{ account_no }}</strong></td>
							</tr>
						</tbody>
					</table>
					<div align="center">
						<hr size="2" align="center" style="width:100%;">
					</div>
					<div class="main-content">
						<p>
							The above matter refers.
						</p>
						<p>
							We hereby confirm and advise that the redemption sum due and payable to us to redeem the above mentioned <br/>
							Loan amount ("<strong>the Redemption Sum</strong>") subject to the following terms and conditions: -
						</p>
						<p>
						<ol>
							<li>
								Below are the redemption sum amount to be received by us
								<table>
									<tr>
										<td><strong>No</strong></td>
										<td><strong>Redemption Date On/Before</strong></td>
										<td><strong>Redemption Amount</strong></td>
									</tr>
									<tr>
										<td>1</td>
										<td>{{ _gHlp.formatMomentDate(_gHlp.getValue(rdmpDetail,'redem_date'),'DD MMMM YYYY') }}</td>
										<td>{{ 'RM '+_gHlp.formatToMoney(_gHlp.getValue(rdmpDetail,'total_repayment',0)) }}</td>										
									</tr>
								</table>
							</li>
							<li>
								Until the redemption sum is paid to us, the Borrower is to continue to pay the monthly repayment which
								will be deducted from the final total of the Redemption Sum.
							</li>
							<li>
								Where the loan is in arrears, this letter of redemption is issued "WITHOUT PREJUDICE" to any of our
								rights
								to proceed with recovery action legally where we shall deem fit to recover the total outstanding balance
								which includes late payment charges (if any).
							</li>
							<li>
								For all intents and purposes, the Loan Agreement and the Letter of Offer shall be valid and subsisting
								notwithstanding the issuance of this Letter by us and any part payment towards the Redemption Sum shall
								not be deemed as a waiver of our rights remedies or action against you unless the full Redemption Sum is
								being received by us.
							</li>
						</ol>
						</p>
						<p style="margin-top: 100px;">
							We trust the above clarifies the matter and should you need further clarification, please do not hesitate
							to
							contact us at 012-347 9128.
						</p>
						<table id="payment_option" border=1 cellpadding=0 cellspacing=0 width="100%">
							<tbody>
								<tr>
									<td colspan="3"><strong>Please remit the Redemption Sum to our Company's account with the following details: - </strong></td>
								</tr>
								<tr>
									<td style="width: 120px;"><strong>Beneficiary</strong></td>
									<td>:</td>
									<td>
										<strong>
											FINTOS CAPITAL SDN. BHD.
											<br />(Formerly known as Invinity Credit Sdn. Bhd.)
										</strong>
									</td>
								</tr>
								<tr>
									<td><strong>Bank</strong></td>
									<td>:</td>
									<td>
										<strong>MAYBANK Berhad</strong><br />
									</td>
								</tr>
								<tr>
									<td><strong>A/C No</strong></td>
									<td>:</td>
									<td>
										<strong>512307622833</strong><br />
									</td>
								</tr>
								<tr>
									<td><strong>Remarks</strong></td>
									<td>:</td>
									<td>
										Ref: [NAME]/[ACCOUNT NO.] (REPAYMENT & REDEMPTION)
										<!-- Please email your payment slip and your name, account no. and mobile number to:<br />
										Email: enquiryfintoscapital@fintos.com.my<br />
										Whatsapp: +6012-347 9128<br /> -->
									</td>
								</tr>
								<tr>
									<td colspan="3">
										*For e-payment transfer confirmation, please email to <strong><i>enquiryfintoscapital@fintos.com.my</i></strong> 
									</td>
								</tr>
							</tbody>
						</table>
						<p>
							Thank you.<br><br>
							Redemption Unit,<br>
							Credit Support &amp; Administration<br>
							For and behalf of<br>
							<strong>FINTOS CAPITAL SDN. BHD.</strong><br>
							<strong>(Formerly known as Invinity Credit Sdn. Bhd.)</strong><br>
							<strong>(Company No.: 198401014613 (127169-T))</strong>
						</p>
						<p style="margin-top:50px; margin-bottom:0pt; text-align:center; line-height:150%; font-size:10pt;">
							<em><span>This is computer generated letter. No signature is required.</span></em>
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="preview">
			<modal :show.sync="is_visible" :hide-footer="true" bodyClasses="preview-modal">
				<div class="text-center">
					<iframe v-if="!_gHlp.isEmpty(pdfUrl)" :src="pdfUrl" class="iframe-preview w-100"></iframe>
				</div>
			</modal>
		</div>
	</div>
</template>
<style>
#doc_redemption_letter {
	width: 100%;
	page-break-inside: auto;
	font-size: 9pt;
	margin-top: 25px;
}
#doc_redemption_letter strong {
	font-weight: 600;
}

#doc_redemption_letter .main-content p {
	page-break-inside: auto;
	width: 100%;
	margin-bottom: 25px;
	word-wrap: break-word;
  overflow-wrap: break-word;
}
#doc_redemption_letter .main-content li {
	width: 100%;
	page-break-inside: auto;
	margin-bottom: 20px;
}
#doc_redemption_letter .main-content li table{
	border: solid 0.5px #585858;	
	margin-top: 15px;
}
#doc_redemption_letter .main-content li table th,
#doc_redemption_letter .main-content li table td{
	padding: 10px;
	border: solid 0.15px #585858;	
	word-wrap: break-word;
  overflow-wrap: break-word;
}

#doc_redemption_letter table {
	page-break-inside: auto;
	border: none;
	border-collapse: collapse;
	margin-bottom: 20px;
}

#doc_redemption_letter table td,
#doc_redemption_letter table th {
	padding: 1px 5px 1px 0px;
}

#doc_redemption_letter table#payment_option {
	page-break-inside: avoid;
	border: solid 0.35px #585858;
	margin-top: 30px;
}
#doc_redemption_letter table#payment_option th,
#doc_redemption_letter table#payment_option td{
	padding: 5px;;
}
</style>
<script>
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { cloneDeep } from 'lodash';

export default {
	data() {
		return {
			// Add your component data here
			pdfUrl: null,
			is_visible: false,
			base64Logo: '',
			rdmpDetail:null
		};
	},
	async created() {
		this.base64Logo = await _gFile.getContentUrl('https://fintos-public.s3.ap-southeast-1.amazonaws.com/fintos_capital.jpg')
		// Add your created lifecycle hook here
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer', 'activeLoanEC']),
		...mapState(useLoanCaseStore, ['activeCase']),
		account_no() {
			let alt = _gHlp.formatDate(_gHlp.getValue(this.activeCase, 'created_at', ''), 'Ymd') + '' + _gHlp.getValue(this.activeCase, 'case_id', '');
			return _gHlp.getValue(this.activeCase, 'account_no', alt);
		},
	},
	watch: {
		'pdfUrl': {
			handler(newValue, oldValue) {
				if (newValue) {
					console.log(newValue);
				}
			},
			immediate: true
		},
	},
	methods: {
		async show(data = null) {
			this.rdmpDetail = cloneDeep(data)
			await this.initPDF();
		},
		async initPDF() {
			// Capture the rendered HTML of the component (inside the `content` div)
			const content = this.$refs.pdf_content;
			this.pdfUrl = await _gFile.htmlToPdfUrl(content, 'Discharge_Letter_' + _gHlp.getValue(this.activeCase, 'case_id', '') + '_' + _gHlp.getCurrentDateTime(false) + '.pdf');
			this.is_visible = true;

		}
	},
	// Add your computed properties here
};
</script>
